export class TimeUtils {
  static formatMillisecondsToShortSec(milliseconds: number): string {
    return `${(milliseconds / 1000).toFixed(2)}s`;
  }

  static differenceInMilliseconds(target: number): number {
    return target - new Date().getTime();
  }

  static getRemainders(milliseconds: number): {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  } {
    const totalSeconds = TimeUtils.getSecondsFromMilliseconds(milliseconds);
    return {
      days: Math.floor(totalSeconds / 60 / 60 / 24),
      hours: Math.floor((totalSeconds / 60 / 60) % 24),
      minutes: Math.floor((totalSeconds / 60) % 60),
      seconds: Math.floor(totalSeconds % 60),
    };
  }

  private static getSecondsFromMilliseconds(milliseconds: number): number {
    return milliseconds / 1000;
  }
}
